import {Component,computed,OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';

import { HttpErrorResponse } from '@angular/common/http';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { DialogService } from '../../services/dialogservice';
import { SelectControlValueAccessor } from '@angular/forms';
import { NotificationService } from '../../services/notificationservice';
import { RegularinvoiceComponent } from './regularinvoice/regularinvoice.component';
import { ToteinvoiceComponent } from './toteinvoice/toteinvoice.component';
import { MatCardContent, MatCard } from "@angular/material/card"; 


@Component({
  selector: 'app-invoiceprocess',
 imports: [MatTabsModule, RegularinvoiceComponent, ToteinvoiceComponent, MatCardContent, MatCard],
 templateUrl: './invoiceprocess.component.html',
  styleUrl: './invoiceprocess.component.scss'
})
export class InvoiceprocessComponent {
 activeTabIndex: WritableSignal<number> = signal(0);
}
